import WebSearch from './webSearch'
export default WebSearch
